import React from "react";
import { useSelector } from "react-redux";
import { getAccountType } from "../../store/auth/selectors";
import {
  checkPermission,
  PERMISSION_TYPES,
} from "../../shared/utils/permissions";
import StudentTable from "../../shared/components/Table/StudentTable";
import Pagination from "../../shared/components/Pagination/Pagination";

const StudentsTabContent = ({
  schoolId,
  error,
  isLoading,
  paginatedStudents,
  totalStudents,
  operation,
  selectedStudents,
  currentPage,
  itemsPerPage,
  onOperationChange,
  onPageChange,
  onItemsPerPageChange,
  onSelectAll,
  onSelectRow,
  columns,
}) => {
  const accountType = useSelector(getAccountType);
  const checkUserPermission = (permissionType) =>
    checkPermission(accountType, permissionType);

  const canResetPassword = checkUserPermission(
    PERMISSION_TYPES.RESET_STUDENT_PASSWORD
  );
  const canDeleteStudent = checkUserPermission(PERMISSION_TYPES.DELETE_STUDENT);
  return (
    <>
      {error ? (
        <div className="error-message">{error}</div>
      ) : isLoading ? (
        <div className="loading-message">Loading students...</div>
      ) : paginatedStudents.length > 0 ? (
        <>
          <div className="students-info">
            <span style={{ fontWeight: "500" }}>
              Total Students: {totalStudents}
            </span>

            <div className="table-controls">
              <select
                className="operation-select bulk-operations"
                value={operation}
                onChange={onOperationChange}
                disabled={selectedStudents.length === 0}
              >
                <option value="">Select Operation</option>
                {canDeleteStudent && (
                  <option value="delete">Delete Student</option>
                )}
                {canResetPassword && (
                  <option value="reset">Reset Password</option>
                )}
              </select>
              <Pagination
                totalItems={totalStudents}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                itemsPerPageOptions={[100, 200, 500, 1000, 2000]}
                onPageChange={onPageChange}
                onItemsPerPageChange={onItemsPerPageChange}
              />
            </div>
          </div>

          <StudentTable
            data={paginatedStudents}
            columns={columns}
            selectedRows={selectedStudents}
            onSelectAll={onSelectAll}
            onSelectRow={onSelectRow}
            showRowSelector={canDeleteStudent || canResetPassword}
          />
        </>
      ) : (
        <div className="no-data-message">Please enter a school ID</div>
      )}
    </>
  );
};

export default StudentsTabContent;
